var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorplifeSvg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 28.001,
    viewBox: "0 0 110 28.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;clip-rule:evenodd;}.b{clip-path:url(#a);}.c{fill:#130f2f;}.d{clip-path:url(#b);}.e{fill:#d2dfe7;}.f{clip-path:url(#c);}.g{opacity:0;}.h{fill:url(#d);}.i{fill:url(#e);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M170.031-68.52a1.015,1.015,0,0,1,1.009-1.022h.689v-2.18H170.22c-1.226,0-2.688.432-2.688,2.492v1.918h-1.291v2.079l1.291.472v8.378h2.5v-8.85h1.7v-2.079h-1.7Zm-12.693,8.935V-71.722h-2.5v12.846c0,2.06,1.462,2.492,2.688,2.492h1.509v-2.18h-.689a1.016,1.016,0,0,1-1.009-1.022Zm-42.463-5.56a2.893,2.893,0,0,1,2.494,1.406l2.23-1.13a5.49,5.49,0,0,0-4.724-2.635,5.534,5.534,0,0,0-5.527,5.656,5.534,5.534,0,0,0,5.527,5.657,5.489,5.489,0,0,0,4.724-2.635l-2.243-1.136a2.918,2.918,0,0,1-2.481,1.412,3.122,3.122,0,0,1-2.99-3.3,3.121,3.121,0,0,1,2.99-3.3Zm32.181,6.6a3.117,3.117,0,0,1-2.916-3.279,3.139,3.139,0,0,1,2.916-3.317,3.083,3.083,0,0,1,2.9,3.3,3.083,3.083,0,0,1-2.9,3.3Zm.34-8.954a4.844,4.844,0,0,0-3.234,1.187l-.354-1h-2.053v14.188h2.518V-57.25a5.015,5.015,0,0,0,3.1,1.059c3.2,0,5.111-2.876,5.111-5.657s-1.9-5.656-5.093-5.656Zm-10.909,1.118-.33-.926h-2.053v10.929h2.519V-62.7a2.329,2.329,0,0,1,2.65-2.08h.473v-2.531h-.473a4.123,4.123,0,0,0-2.786.926Zm23.593,1.153,1.291.472v8.378h2.519V-67.312h-3.81Zm2.352-5.8a1.5,1.5,0,0,0-1.5,1.534,1.5,1.5,0,0,0,1.5,1.534,1.545,1.545,0,0,0,1.533-1.553,1.545,1.545,0,0,0-1.533-1.515ZM126.188-58.55a3.122,3.122,0,0,1-2.99-3.3,3.121,3.121,0,0,1,2.99-3.3,3.094,3.094,0,0,1,3.011,3.3,3.13,3.13,0,0,1-3.011,3.3Zm0-8.954a5.534,5.534,0,0,0-5.527,5.656,5.534,5.534,0,0,0,5.527,5.657,5.552,5.552,0,0,0,5.566-5.657,5.552,5.552,0,0,0-5.566-5.656Zm49.244,4.6a2.806,2.806,0,0,1,2.755-2.243A2.391,2.391,0,0,1,180.6-62.9Zm2.66-4.6a5.4,5.4,0,0,0-5.32,5.695,5.478,5.478,0,0,0,5.584,5.618,8.6,8.6,0,0,0,3.756-.916l.4-.207-.9-2.057-.43.19a7.122,7.122,0,0,1-2.784.631,2.868,2.868,0,0,1-2.971-2.166h7.514l.069-.4a5.585,5.585,0,0,0,.064-.889c0-2.734-1.71-5.5-4.979-5.5Z",
    transform: "translate(-109.348 71.722)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.081-61.856C4.834-62,1.028-62.172,2.105-60.118c.042.07.08.142.123.211l.006.008A2.957,2.957,0,0,0,4.7-58.526a14.6,14.6,0,0,0,1.943-.1,50.444,50.444,0,0,0,7.3-1.51,57.8,57.8,0,0,0-7.86-1.72m20.608-3.532a2.977,2.977,0,0,0-2.164-1.371,14.033,14.033,0,0,0-3.32.007,50.275,50.275,0,0,0-7.264,1.5,54.415,54.415,0,0,0,7.829,1.711c1.957.217,5.816-.281,4.92-1.848m-4.214,7.865q-.621.019-1.27.095a50.376,50.376,0,0,0-7.281,1.505c.217.059,3.181.862,4.565,1.158a2.887,2.887,0,0,0,1.985-.272,13.826,13.826,0,0,0,2.327-1.6.5.5,0,0,0-.325-.889m-.708-15.351c1.247.147,5.054.316,3.976-1.738-.042-.07-.08-.142-.123-.211l-.005-.008A2.956,2.956,0,0,0,23.148-76.2a14.486,14.486,0,0,0-1.943.1,50.452,50.452,0,0,0-7.3,1.51,57.908,57.908,0,0,0,7.86,1.72m-15.124,4.9a50.275,50.275,0,0,0,7.264-1.5A54.4,54.4,0,0,0,6.079-71.19c-1.957-.216-5.816.281-4.919,1.848A2.977,2.977,0,0,0,3.324-67.97a14.03,14.03,0,0,0,3.32-.007m-1.27-9.229q.621-.019,1.27-.095a50.379,50.379,0,0,0,7.281-1.506c-.217-.059-3.181-.862-4.565-1.158a2.889,2.889,0,0,0-1.985.272,13.86,13.86,0,0,0-2.327,1.6.5.5,0,0,0,.325.889",
    transform: "translate(-1.026 80.032)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.37-67.21l0,0A3.039,3.039,0,0,0,26-68.024c.9,1.566-2.963,2.064-4.92,1.848a54.409,54.409,0,0,1-7.829-1.711,50.427,50.427,0,0,0-7.3-1.51A14.043,14.043,0,0,0,2.641-69.4a3,3,0,0,0-2.5,3.89,14.031,14.031,0,0,0,1.275,2.761C.342-64.807,4.148-64.638,5.4-64.491a57.762,57.762,0,0,1,7.86,1.72,50.308,50.308,0,0,0,7.264,1.5,14.557,14.557,0,0,0,1.952.1,2.952,2.952,0,0,0,2.467-1.377h0a14.029,14.029,0,0,0,1.4-2.973h0s0-.006,0-.009a2.993,2.993,0,0,0,.093-.387c0-.027.009-.054.013-.081a2.954,2.954,0,0,0,.029-.331c0-.027,0-.053,0-.08a2.942,2.942,0,0,0-.1-.77c0-.01,0-.021-.006-.03M17.8-57.4c-1.015-.217-2.875-.705-3.883-.974a77.887,77.887,0,0,0-7.963-1.689c-.433-.051-.856-.081-1.269-.093a.5.5,0,0,0-.328.887A13.662,13.662,0,0,0,13.238-56a13.611,13.611,0,0,0,6.532-1.664A2.886,2.886,0,0,1,17.8-57.4M.107-72.79l0,0a3.031,3.031,0,0,0,.364.815c-.9-1.567,2.963-2.064,4.92-1.848a54.391,54.391,0,0,1,7.829,1.712,50.426,50.426,0,0,0,7.3,1.51,14.044,14.044,0,0,0,3.317.007,3,3,0,0,0,2.5-3.891,14.01,14.01,0,0,0-1.275-2.761c1.078,2.054-2.729,1.885-3.976,1.738a57.915,57.915,0,0,1-7.86-1.72,50.219,50.219,0,0,0-7.264-1.5,14.619,14.619,0,0,0-1.952-.1,2.954,2.954,0,0,0-2.467,1.377h0a14.007,14.007,0,0,0-1.4,2.973h0l0,.009a2.972,2.972,0,0,0-.093.387c0,.027-.009.054-.013.081a2.947,2.947,0,0,0-.029.331c0,.027,0,.053,0,.08a2.954,2.954,0,0,0,.1.77c0,.01,0,.02.006.031M8.674-82.6c1.015.217,2.874.706,3.883.975a77.982,77.982,0,0,0,7.963,1.689q.65.076,1.269.093a.5.5,0,0,0,.328-.886A13.659,13.659,0,0,0,13.238-84a13.612,13.612,0,0,0-6.532,1.664A2.887,2.887,0,0,1,8.674-82.6",
    transform: "translate(0 84.001)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x2: 0,
    y2: 12.19,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f1126a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f42454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f8363e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fc4728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fe5915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fa6c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f67f12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#eea510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eab80f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    y1: 0.496,
    x2: 0.24,
    y2: 0.496,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed0080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#f1126a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#f42454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f8363e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fc4728"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fe5915"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fa6c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f67f12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#f29211"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#eea510"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eab80f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 84)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(36.276 -79.875)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M104.348-76.722h77.041v21.958H104.348Z",
    transform: "translate(-106.007 75.042)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(0.34 -82.667)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-3.974-85.032H25.14v28.694H-3.974Z",
    transform: "translate(2.315 83.352)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(0 -84.001)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M0,0H110.143V28.225H0Z",
    transform: "translate(0 -0.001)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M0,0H110.143V28.225H0Z",
    transform: "translate(0 -0.001)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorplifeSvg);
export default __webpack_public_path__ + "static/media/corplifeSVG.a7a5d0bf2b197f162b290c7b1d60ec02.svg";
export { ForwardRef as ReactComponent };